module.exports = __webpack_public_path__ + "static/media/preloader-Big-HIPPO-withText-Pet.229f7583.gif";